import React from "react";
import { Route, Routes } from "react-router-dom";
import { UserList } from "./list";
import { EditUser } from "./edit";

export default () => {
  return (
    <Routes>
      <Route index element={<UserList />} />
      <Route path="/:id" element={<EditUser />} />
    </Routes>
  );
};
